(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["menu-image-panel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.image-menu').forEach((menu) => {
      if (!menu.matches(':hover, :focus-within')) return;
      if (menu.contains(document.activeElement)) menu.querySelector('.header__menu_item').focus();
      menu.classList.add('is-dismissed');
    });
  });
  ['pointerover', 'focusin'].forEach((type) => {
    document.addEventListener(type, (event) => {
      const menu = event.target.closest('.image-menu');
      if (menu && !menu.contains(event.relatedTarget)) menu.classList.remove('is-dismissed');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
